import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Slider from '@mui/material/Slider'

function formatRam(gb: number) {
  return gb >= 1024 ? `${gb / 1024} TB` : `${gb} GB`
}

// Slider positions are powers of two: position n <-> 2^n GB.
const toPosition = (gb: number) => Math.max(0, Math.round(Math.log2(Math.max(1, gb))))
const toGb = (position: number) => 2 ** position

type RamSliderProps = {
  value: number[]
  maxRAM: number
  setValue: (value: number[]) => void
}

const RamSlider: React.FC<RamSliderProps> = ({ value, maxRAM, setValue }) => {
  const maxPosition = toPosition(Math.max(2, maxRAM))

  return (
    <Box>
      <Typography gutterBottom id="ram-slider-label">
        Memory: {formatRam(Math.max(1, value[0]))} – {formatRam(Math.max(1, value[1]))}
      </Typography>
      <Slider
        value={[toPosition(value[0]), toPosition(value[1])]}
        min={0}
        step={1}
        max={maxPosition}
        scale={toGb}
        getAriaValueText={formatRam}
        valueLabelFormat={formatRam}
        onChange={(_e, newValue) => {
          if (Array.isArray(newValue)) {
            setValue(newValue.map(toGb))
          }
        }}
        valueLabelDisplay="auto"
        aria-labelledby="ram-slider-label"
        marks
      />
    </Box>
  )
}

export default RamSlider
